import React from 'react';
import {connect} from "react-redux";
import * as portActions from "../../actions/port";
import l10n from "../../l10n/localization";
import Loader from "../common/Loader";
import validation from '../../validation/port';
import Validate from 'validate.js';
import * as utilsCommon from "../../utils/utils";
import CWForm from "./CWForm";
import SelectCountries from "./fields/SelectCountries";
import * as utils from "../../utils/port";
import * as countryActions from "../../actions/country";

class PortForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            item: utilsCommon.notNullNorUndefined(this.props.item) ? this.props.item.item : null,
            schema: {
                type: "object",
                properties: {
                    name: {
                        type: "string",
                        title: l10n.port.name,
                    },
                    country: {
                        type: "string",
                        title: l10n.common.country,
                    },
                }
            },
            uiSchema: {
                name: {
                    "ui:emptyValue": ""
                },
                country: {
                    "ui:field": "selectCountries",
                },
            },
            fields: {
                selectCountries: SelectCountries,
            },
            isDirty: false,
            formData: utils.portToForm(utilsCommon.notNullNorUndefined(this.props.item) ? this.props.item.item : null)
        }
    }

    componentDidMount() {
        this.props.dispatch(countryActions.fetchCountries());
    }

    onSubmit = ({formData}) => {
        let form = Object.assign({}, {...formData});

        if (utilsCommon.notNullNorUndefined(this.state.item) && (utilsCommon.notNullNorUndefined(this.state.item.id) || utilsCommon.notNullNorUndefined(this.props.newlyCreatedElement))) {
            if (utilsCommon.notNullNorUndefined(this.props.newlyCreatedElement)) {
                this.setState({item: {...formData, id: this.props.newlyCreatedElement}}, () => {
                    form.id = this.props.newlyCreatedElement;
                    this.props.dispatch(portActions.edit(form));
                })
            } else {
                this.setState({item: formData}, () => {
                    this.props.dispatch(portActions.edit(form));
                })
            }
        } else {
            this.setState({item: formData}, () => {
                this.props.dispatch(portActions.add(form));
            })
        }
        this.setState((state) => {return {...state, isDirty: false,formData: formData};});
    };

    validate = (formData, errors) => {
        let validationErrors = Validate(formData, validation, {fullMessages: false});

        if (validationErrors !== undefined) {
            for (let key in validationErrors) {
                if (validationErrors.hasOwnProperty(key)) {
                    if (errors[key] !== undefined) {
                        for (let i = 0; i < validationErrors[key].length; i++) {
                            errors[key].addError(validationErrors[key][i]);
                        }
                    }
                }
            }
        }
        return errors;
    };

    handleError = () => {
        this.props.dispatch(portActions.errorMessage(l10n.validation.form_error));
    };

    handleChange = (formData) => {
        let nextState = this.state;

        if(!this.state.isDirty) {
            nextState.isDirty = true;
        }
        nextState.formData = formData.formData;
        this.setState((state) => {return {...state, nextState}});
    };

    render() {
        if (this.props.loading || this.props.saving) {
            return (<div><Loader /></div>)
        }
        let formClassName = (this.state.isDirty) ? 'port-form dirty':'port-form';

        return (
            <div className={formClassName}>
                <h1>Port</h1>
                <CWForm
                    schema={this.state.schema}
                    uiSchema={this.state.uiSchema}
                    formData={this.state.formData}
                    showErrorList={false}
                    validate={this.validate}
                    liveValidate={true}
                    onSubmit={this.onSubmit}
                    onError={this.handleError}
                    onChange={({formData})=> {this.handleChange({formData})}}
                    fields={this.state.fields} >
                    <div>
                        <button type="submit" className="btn btn-info validate" disabled={this.props.saving}>{l10n.common.save}</button>
                    </div>
                </CWForm>
            </div>
        )
    }
}

export default connect((state) => {
    return Object.assign({}, {
        loading: state.port.loading,
        saving: state.port.saving,

        newlyCreatedElement: state.creation.newlyCreatedPort,
    });
})(PortForm);



// WEBPACK FOOTER //
// ./src/components/forms/PortForm.js